module.exports = __webpack_public_path__ + "img/50eb243.png";